import { render } from "./VideoPlayer.vue?vue&type=template&id=23caed07"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "video.js/dist/video-js.min.css?vue&type=style&index=0&lang=css"
import "./VideoPlayer.vue?vue&type=style&index=1&id=23caed07&lang=scss"
script.render = render

export default script